<template>
    <div class="d-flex justify-space-between stk">
        <div class="pt-1 pl-2 d-flex justify-space-between align-center" v-if="$vuetify.breakpoint.smAndDown">
            <v-img 
                :src="require(`@/assets/maya/_/logo_plata.png`)" 
                max-width="150px" contain
                @click="$router.push('/')"
                style="cursor:pointer"></v-img>
            
            <v-btn text href="https://www.sgs.com/en/certified-clients-and-products" target="_blank">
                <v-img 
                    style="margin-left:40px"
                    :src="require(`@/assets/maya/_/logo-iso.png`)" 
                    max-width="70px" alt="ISO" contain></v-img>
            </v-btn>
        </div>

        <div class="pt-1 pl-1" v-if="$vuetify.breakpoint.mdAndUp">
            <v-img 
                :src="require(`@/assets/maya/_/hecho-en-mexico.png`)" 
                max-width="180px" alt="Hecho en México"  contain
                @click="$router.push('/')"
                style="cursor:pointer"></v-img>
        </div>

        <div class="pt-6 pl-1" v-if="$vuetify.breakpoint.mdAndUp">
            <v-btn text href="https://www.sgs.com/en/certified-clients-and-products" target="_blank">
                <v-img 
                    :src="require(`@/assets/maya/_/logo-iso.png`)" 
                    max-width="110px" alt="ISO"  contain></v-img>
            </v-btn>
        </div>

        <div v-if="!statusDrawer">
            <v-btn icon class="pl-6 pr-6" @click="openDrawer">
                <v-icon color="white">fa-bars</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        statusDrawer() {
            return this.$store.getters.statusDrawer;
        }
    },
    methods: {
        openDrawer() {
            this.$store.dispatch('setStatusDrawer', true);
        }
    }
}
</script>